import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    address,
    lastTime,
    taxCalculationPeriod,
  },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [address.name]: "",
  [lastTime.name]: "",
  [taxCalculationPeriod.name]: "",
};

export default initialValues;
